// src/component/Footer/index.jsx
import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { GithubOutlined, WechatOutlined, QqOutlined, HeartFilled, CoffeeOutlined, BookOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './index.css';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const AppFooter = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    const handleSocialLogin = (socialType) => {
        if (!isAuthenticated) {
            navigate('/auth', { state: { socialLogin: socialType } });
        } else {
            alert(`您已登录，当前使用${socialType}登录功能`);
        }
    };

    return (
        <AntFooter className="app-footer">
            <Text strong style={{ fontSize: '1.1rem', color: '#0c4a6e' }}>
                <HeartFilled style={{ color: '#f97316' }} /> 我的博客 - 分享知识，传递价值
            </Text>
            <Space size="large" className="social-links" wrap>
                <a 
                    href="https://github.com" 
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSocialLogin('GitHub');
                    }}
                    className="social-link"
                    title="GitHub"
                >
                    <GithubOutlined style={{ fontSize: '26px', color: '#0c4a6e' }} />
                </a>
                <a 
                    href="https://weixin.qq.com" 
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSocialLogin('微信');
                    }}
                    className="social-link"
                    title="微信"
                >
                    <WechatOutlined style={{ fontSize: '26px', color: '#0c4a6e' }} />
                </a>
                <a 
                    href="https://im.qq.com" 
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSocialLogin('QQ');
                    }}
                    className="social-link"
                    title="QQ"
                >
                    <QqOutlined style={{ fontSize: '26px', color: '#0c4a6e' }} />
                </a>
            </Space>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <Text type="secondary">
                    <CoffeeOutlined style={{ marginRight: '4px' }} />
                    一杯咖啡，一份支持
                </Text>
                <Text type="secondary">
                    <BookOutlined style={{ marginRight: '4px' }} />
                    知识共享，共同成长
                </Text>
            </div>
            <Text type="secondary" style={{ marginTop: '8px' }}>
                © 2025 我的博客. All Rights Reserved. | Designed with ❤️ using React & Ant Design
            </Text>
        </AntFooter>
    );
};

export default AppFooter;